import { TypeInitProps, TypeRequest } from '../../types';
import { encryptParams } from '../../utils/index';
import { WEB_URL } from '../../utils/urls';
export default class ExtraAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @param {string} mobile - the mobile to check
   * @return {Promise} check result
   */
  checkMobileRegistered = (params: {
    mobile: string;
    extra_params?: object;
  }) => {
    const { mobile, extra_params = {} } = params;
    const data = encryptParams({ mobile, ...extra_params }, ['mobile']);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.CHECK_MOBILE_REGISTER,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} email - the email to check
   * @return {Promise} check result
   */
  checkEmailRegistered = (params: { email: string; extra_params?: object }) => {
    const { email, extra_params = {} } = params;
    const data = encryptParams({ email, ...extra_params }, ['email']);
    return this.request({
      url: WEB_URL.CHECK_EMAIL_REGISTER,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} mobile - mobile
   * @param {number} type - send code type
   * @return {Promise} send result
   */
  sendCode = (
    params: {
      mobile?: string;
      type?: number;
      extra_params?: object;
      method?: 'GET' | 'POST';
    } = {}
  ) => {
    const { mobile, type, extra_params = {}, method = 'POST' } = params;
    const data = encryptParams({ mobile, type, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method,
      data,
    });
  };

  /**
   * @param {string} email - email
   * @param {number} type - send code type
   * @return {Promise} send result
   */
  sendEmailCode = (
    params: {
      email?: string;
      type?: number;
      extra_params?: object;
    } = {}
  ) => {
    const { email, type, extra_params = {} } = params;
    const data = encryptParams(
      {
        email,
        type,
        ...extra_params,
      },
      ['email', 'type']
    );
    return this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} verify result
   */
  validateMobile = (
    params: {
      code?: string;
      type?: number;
      extra_params?: object;
    } = {}
  ) => {
    const { code, type, extra_params = {} } = params;
    let data = encryptParams({ code, type, ...extra_params }, ['code', 'type']);
    return this.request({
      url: WEB_URL.VERIFY_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} - verify result
   */
  validateCode = (
    params: {
      mobile?: string;
      code?: string;
      type?: number;
      extra_params?: object;
    } = {}
  ) => {
    const { mobile, code, type, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, type, ...extra_params }, [
      'mobile',
      'code',
      'type',
    ]);
    return this.request({
      url: WEB_URL.CHECK_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} email - email to be verified
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} - verify result
   */
  validateEmailCode = (
    params: {
      email?: string;
      code?: string;
      type?: number;
      extra_params?: object;
    } = {}
  ) => {
    const { email, code, type, extra_params = {} } = params;
    const data = encryptParams({ email, code, type, ...extra_params }, [
      'email',
      'code',
      'type',
    ]);
    return this.request({
      url: WEB_URL.CHECK_EMAIL_CODE,
      method: 'POST',
      data,
    });
  };
}
